export default "__VITE_ASSET__C0KP4i1K__"